<div class="dialog">
  <h4 mat-dialog-title>{{ 'common_modify' | translate }}</h4>
  <form #form="ngForm" [appEnterToSave]="data">
    <mat-form-field>
      <mat-label>{{ 'common_field_quantity' | translate }}</mat-label>
      <input matInput type="number" [(ngModel)]="data.quantity" name="quantity" required />
      <mat-error *ngIf="!data?.quantity" [innerHTML]="'common_error_quantity_required_alt' | translate"></mat-error>
    </mat-form-field>
    <div mat-dialog-actions>
      <button type="button" mat-button (click)="onNoClick()">{{ 'common_btn_cancel' | translate }}</button>
      <button mat-button [mat-dialog-close]="data" color="accent" [disabled]="!form.valid">{{ 'common_btn_save' | translate }}</button>
    </div>
  </form>
</div>
